import React from 'react';
import Grid from '@mui/material/Grid';
// import Avatar from '@mui/material/Avatar';
import { Link, Typography } from '@mui/material';



const CCA2025 = () => {
  return (
    
    <Typography align='center' variant='h4' fontWeight={800}>
    Co-Curricular Activities 2025-26</Typography>
  );
};

export default CCA2025;
